export default "__VITE_ASSET__a35a7763__"